module.exports = "/_next/static/images/6e7bf531c8ae64abd39343df449d2af1-get-earnings.gif";